import { apiClient } from "./client";

export type PermLevel = "none" | "read" | "write";

export interface MyService {
  id: string;
  name: string;
  role: string;
  is_owner: boolean;
}

export interface MyPermissions {
  service_id: string;
  role: string;
  permissions: Record<string, PermLevel>;
}

export interface Member {
  id: string;
  admin_user_id: string;
  email: string;
  name: string;
  role: string;
  is_owner: boolean;
}

export interface Invite {
  id: string;
  token: string;
  link: string;
  email: string | null;
  role: string;
  expires_at: string;
}

export interface RoleDef {
  id: string;
  name: string;
  permissions: Record<string, PermLevel>;
  builtin: boolean;
}

export const memberService = {
  myServices: async (): Promise<MyService[]> => (await apiClient.get("/admin/me/services")).data,
  myPermissions: async (): Promise<MyPermissions> =>
    (await apiClient.get("/admin/me/permissions")).data,
  listMembers: async (): Promise<Member[]> => (await apiClient.get("/admin/members")).data,
  updateMember: async (id: string, role: string): Promise<Member> =>
    (await apiClient.patch(`/admin/members/${id}`, { role })).data,
  removeMember: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/members/${id}`);
  },
  createInvite: async (body: { email?: string | null; role: string }): Promise<Invite> =>
    (await apiClient.post("/admin/invites", body)).data,
  listInvites: async (): Promise<Invite[]> => (await apiClient.get("/admin/invites")).data,
  revokeInvite: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/invites/${id}`);
  },
  acceptInvite: async (
    token: string
  ): Promise<{ service_id: string; service_name: string; role: string }> =>
    (await apiClient.post("/admin/invites/accept", { token })).data,
  listRoles: async (): Promise<RoleDef[]> => (await apiClient.get("/admin/roles")).data,
  createRole: async (body: {
    name: string;
    permissions: Record<string, PermLevel>;
  }): Promise<RoleDef> => (await apiClient.post("/admin/roles", body)).data,
  updateRole: async (
    id: string,
    body: { name?: string; permissions?: Record<string, PermLevel> }
  ): Promise<RoleDef> => (await apiClient.patch(`/admin/roles/${id}`, body)).data,
  deleteRole: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/roles/${id}`);
  },
};
